const { VITE_BRAND } = import.meta.env;

export default {
  ivtNameListTitle: 'Winning list',
  ivtWinTitle: 'List of Winners in This Edition',
  ivtLastWinTitle: 'List of previous winners',
  ivtInviteTitle: 'My Invitation',
  ivtName: 'User name',
  ivtTime: 'Registration Date',
  ivtInviteNo: 'Start inviting your friends now and you can win prizes',
  ivtPrizeNo: 'There is no previous winning list',
  InvitedName: `invites you to be part of us.`,
  InvitedHistoryBtn: 'My Invitation',
  InvitedRegisterBtn: 'Register Now',
  invitedNumber: 'You have invited {number} {member}.',
  prizeNeedNumber: 'Invite {number} {member} and try to win it.',
  allowPrizeNumber: 'Invite {number} more {member} and try to win it.',
  unlockText: 'You are now in the prize draw.',
  nowWinBtn: 'Winning list',
  loginWinPrize: 'Log in to your account and invite friends to win big prizes!',
  loginViewMess: 'Log in to your account and view invitation information',
  noInviter: 'Start inviting your friends now and you can win prizes',
  inviterHistory: 'My Invites',
  inviterTime: 'Activity time :',
  needKnow: 'Rules',
  wonderfulContent: 'Join the Community and you can',
  inviteText: `Invites you to join the ${VITE_BRAND === 'ONEPLUS' ? 'OnePlus' : 'OPPO'} Community`,
  posterSaveBtn: 'Save',
  posterShareBtn: 'Share',
  sureBtn: 'Got it',
  RafflesName: 'Raffles',
  randomReward: 'Random reward',
  loginBtnName: 'Log in or register',
  endBtnName: 'The activity has ended',
  posterBtn: 'Generate Poster',
  inviteBtn: 'Invite now',
  posterBtnNoshow: 'Saving images is currently not supported. Please take a screenshot yourself',
  copyToast: 'Link copied successfully',
  appNotShare: 'The current App version is too low, please update and try again',
  oldUSerMess: `Sorry, the invite didn't work out because the invited person had logged into the Community before.`,
  newUserMess: 'Registration successful',
  ipLimitMess: 'The number of registrations of the current IP has exceeded the limit',
  endToast: `The activity has ended. You can visit the ${
    VITE_BRAND === 'ONEPLUS' ? 'OnePlus' : 'OPPO'
  } Community, join the conversations and discover more.`,
  policy: 'Terms & Conditions',
  pcTips: `This page is only accessible on mobile browsers and the Community App. Please try again using one.`,
  activityDetail: 'Activity Detail',
  steps:'Activity Steps',

  fistComeWiner:'First come first serve',
  pocInviterMore:'Invite {number} more {member} and to win!',
  pocFailTips:'This prize is no longer available. But you can still share the product with your friends to get the chance to try it out!',
  pocSucessTips:'Congratulations! You won the prize!',
  coupons:'Only {number} left',
  zerocoupons:'0 left',
  surplus:'Successfully invite {number} people to receive the award：',
  pocLoginViewMess:'Log into your account to view invite information.',
  pocNoInviter: 'Invite friends now and you could win prizes.',
  Invited:'Invited'
} 